class CartCount extends HTMLElement {
  constructor() {
    super();
    this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        const cart = event.cart;
        if (cart.item_count === 0) {
          this.hidden = true;
          return;
        }

        const count = cart.item_count < 100 ? cart.item_count : '99+';
        const countText = cart.item_count < 100 ? cart.item_count : '99+';

        if (this.hidden) {
          this.hidden = false;
        }

        const existingCountElement = this.querySelector('.cart-count-value');
        if (existingCountElement) {
            existingCountElement.textContent = countText;
        } else {
            this.textContent = countText;
        }

        this.setAttribute('aria-label', FoxTheme.cartStrings.cart_count.replace('[count]', count));
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', CartCount);
} 